export type DoorStatus = 'open' | 'closed';
export type DoorSide = 'front' | 'back';

export interface CubbyState extends Record<DoorSide, DoorStatus> {
    id: number;
    orderId: number | null;
    color: LockerColors;
    occupied: boolean;
}

export interface DoorEvent {
    doorSide: DoorSide;
    cubbyIndex: number;
    orderId?: number;
}
export interface DoorEventData extends DoorEvent {
    color: LockerColors;
    occupied?: boolean;
    // orderId?: number;
}
export interface CubbyUpdateEventData {
    id: number;
    color?: LockerColors;
    occupied?: boolean;
    orderId?: number | null;
}

export type LockerState = Record<number, CubbyState>;

export const LOCKER_COLORS = {
    red: 'ff0000',
    blue: '0000ff',
    green: '00ff00',
    teal: '00ffff',
    purple: 'ff00ff',
    yellow: 'ffff00',
    orange: 'ff8800',
    white: 'ffffff',
    black: '000000',
} as const;
export type LockerColors = keyof typeof LOCKER_COLORS;

export const IDLE_COLOR: LockerColors = 'teal';
export const LOADING_ORDER_COLOR: LockerColors = 'white';
export const ORDER_READY_COLOR: LockerColors = 'green';
export const PICKING_UP_ORDER_COLOR: LockerColors = 'orange';
